import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import * as model from '../../../../models';
import { Store } from "@ngrx/store";
import { Subscription } from 'rxjs/Rx';
import * as moment from 'moment';
import { EventApi } from "../../../../services/webservice"
import { AppState } from "../../../../reducers";
import { EventBasicData, SeasonEventRef } from "../../../../models"
import { MessageActions } from '../../../../actions';
import { ErrorHandlerService } from '../../../../services';

@Component({
	selector: 'season-event-list-selection',
	template: `
		<season-event-list-selection-presentation
				[showEventSelectionPopup]="showEventSelectionPopup"
				(hideEventSelectionClicked)="hideEventSelection()"
				(saveSelectedEventsClicked)="saveSeasonEvents($event)"
				[events]="seasonEvents"
				[selectedEventStorageIds]="selectedSeasonEvents"
		></season-event-list-selection-presentation>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class SeasonEventListSelectionComponent {
	seasonEvents: EventBasicData[];
	selectedSeasonEvents: number[];
	protected loadedEvent: model.Event;

	@Input() showEventSelectionPopup: boolean;
	@Output() hideEventSelectionClicked = new EventEmitter<void>();

	private subscription: Subscription;

	constructor(
		private store: Store<AppState>,
		private eventApi: EventApi,
		private changeDetectorRef: ChangeDetectorRef,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService
	) {}

	ngOnInit() {
		this.subscription = this.store.select("eventServerState", "event", "currentEvent").subscribe((event: model.Event) => {
			if (!event) return;
			this.loadedEvent = event;

			this.eventApi.findBySeasonEventProperty().subscribe(
				seasonEvents => {
					this.seasonEvents = seasonEvents.sort((seasonEventA, seasonEventB) =>
						moment(seasonEventB.begin, "YYYY-MM-DD'T'HH:mm:ss").diff(moment(seasonEventA.begin, "YYYY-MM-DD'T'HH:mm:ss")));
					this.changeDetectorRef.markForCheck();
				}
			);

			this.eventApi.getSeasonEventRef(event.storageId).subscribe(
				seasonEventRef => {
					this.selectedSeasonEvents = seasonEventRef.seasonEvents
						.map(seasonEvent => seasonEvent.storageId);
					this.changeDetectorRef.markForCheck();
				});
		})
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	saveSeasonEvents(eventStorageIds: number[]) {
		this.eventApi.setSeasonEventRef(eventStorageIds, this.loadedEvent.storageId).subscribe(
			() => {
				this.store.dispatch(this.messageActions.displayMessage('Die Zuordnung wurde gespeichert.', 'success'));
			}, error => {
				const errorMessage = this.errorHandler.getErrorMessage(error, "Die Dauerkartenveranstaltungen konnten nicht zugeordnet werden.");
				this.store.dispatch(this.messageActions.displayMessage(errorMessage, "error"));
			}
		)
	}

	hideEventSelection() {
		this.hideEventSelectionClicked.emit();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/season-events/season-event-list-selection/season-event-list-selection.component.ts